/** Минимальная типизация того, чем мы реально пользуемся из Telegram WebApp SDK. */
interface HapticFeedback {
  impactOccurred(style: 'light' | 'medium' | 'heavy' | 'rigid' | 'soft'): void;
  notificationOccurred(type: 'error' | 'success' | 'warning'): void;
  selectionChanged(): void;
}

interface TelegramWebApp {
  initData: string;
  initDataUnsafe: { start_param?: string; user?: { id: number; first_name?: string } };
  colorScheme: 'light' | 'dark';
  themeParams: Record<string, string>;
  HapticFeedback?: HapticFeedback;
  ready(): void;
  expand(): void;
  disableVerticalSwipes?(): void;
  onEvent(event: string, cb: () => void): void;
  close(): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: TelegramWebApp };
  }
}

export const tg = (): TelegramWebApp | undefined => window.Telegram?.WebApp;

/** Тема Telegram может поменяться на лету — отражаем её на корне документа. */
function applyTheme(): void {
  const app = tg();
  document.documentElement.dataset.theme = app?.colorScheme ?? 'light';
}

export function initTelegram(): void {
  const app = tg();
  if (!app) {
    // Открыли в обычном браузере (например, при разработке).
    document.documentElement.dataset.theme = window.matchMedia('(prefers-color-scheme: dark)')
      .matches
      ? 'dark'
      : 'light';
    return;
  }
  app.ready();
  app.expand();
  // Свайп вниз посреди тренажёра закрывал бы приложение прямо во время игры.
  app.disableVerticalSwipes?.();
  applyTheme();
  app.onEvent('themeChanged', applyTheme);
}

/** Строка подписи, которую сервер проверяет на каждом запросе. */
export function initData(): string {
  return tg()?.initData ?? '';
}

/**
 * Куда открыть приложение. Кнопки бота ведут на /?open=chord_Em и подобное,
 * а startapp-ссылка кладёт то же значение в start_param.
 */
export function openTarget(): string {
  const fromUrl = new URLSearchParams(window.location.search).get('open');
  return fromUrl ?? tg()?.initDataUnsafe.start_param ?? '';
}

export const haptic = {
  tap(): void {
    tg()?.HapticFeedback?.selectionChanged();
  },
  done(): void {
    tg()?.HapticFeedback?.notificationOccurred('success');
  },
};
